module.exports = __webpack_public_path__ + "img/a6.fc23926d.svg";